import { createStyles } from '@mantine/core';

var useStyles = createStyles((theme) => ({
  timeWrapper: {
    display: "flex",
    marginTop: theme.spacing.md
  },
  timeInput: {
    flex: 1,
    marginRight: theme.spacing.md
  }
}));

export default useStyles;
//# sourceMappingURL=DateTimePicker.styles.js.map
